var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shortAnswer"},[_c('div',{staticClass:"top"},[_vm._v(" 题目： "),_c('el-input',{staticStyle:{"width":"70%"},attrs:{"placeholder":"请输入题目","type":"textarea","autosize":""},model:{value:(_vm.smallTopic.topicName),callback:function ($$v) {_vm.$set(_vm.smallTopic, "topicName", $$v)},expression:"smallTopic.topicName"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }